<script>
//SimpleText.vue

export default {
    props: {
        facetTitle: {
            type: String,
            required: true
        },
        filter: {
            type: Object,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        limitOptions: {
            type: Number,
            required: true
        },
        value: {
            type: String,
        },
        filterOptions: {
            type: Boolean,
            default: false,
        },
        activeFacet: {
            type: Boolean,
            default: true,
        },
        defaultOption: {
            type: String,
            default: "",
        },
        showCounts: {
            type: Boolean,
            default: true,
        },
        group: Boolean,
    },
    data() {
        return {
            id: _.uniqueId(),
            selectedValue: this.value ?? "",
            showFacet: !!this.value,
        }
    },
    methods: {
        reset() {
            this.selectedValue = "";
        },
        performSearchInput:  _.debounce((value, vm) => {
            vm.$emit('input', value == "" ? null : value);
        }, 1500),
    },
    watch: {
        value(newValue) {
            this.selectedValue = newValue ?? "";
        },
        selectedValue(value) {
            this.performSearchInput(value, this);
        }
    },

}
</script>

<template>
    <div>
        <div v-if="activeFacet">
        <div class="search-wrapper">
            <div class="input-group">
                <input class="form-control backz"
                       type="text"
                       :id="id"
                       v-model="selectedValue"
                       :placeholder="defaultOption"
                />
                <span class="input-group-addon">
                                    <button @click="reset()" class="btn btn-outline btn-xs" type="button"><i
                                        class="fa fa-eraser"></i></button>
                                </span>
            </div>
        </div>
    </div>
        <div v-else>
            <div class="search-wrapper">
                <div class="input-group">
                    <input class="form-control backz"
                           type="text"
                           disabled
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.backz {z-index: 0!important;}
.simpleText {
    padding: 4px;
    margin: 0;
}

.input-group-addon {
    padding: 5px 10px;
    border: 0;
}

.input-group-addon button i {
    color: #c4c4c4;
}

.title span i {
    margin-left: 5px;
    color: #c4c4c4;
}

.search-wrapper {

}

</style>
